export default __webpack_public_path__ + "static/media/8.4248d925.JPG";